import React, {useEffect, useRef, useState} from 'react'
import {useAuth} from '../../../modules/auth'
import {getDownloadURL, ref, uploadBytes} from 'firebase/storage'
import db, {storage} from '../../../../services/firebase'
import {
  getAuth,
  updatePassword,
  reauthenticateWithCredential,
  EmailAuthProvider,
} from 'firebase/auth'
import {
  DocumentData,
  DocumentReference,
  QueryDocumentSnapshot,
  WriteBatch,
  addDoc,
  collection,
  doc,
  getDocs,
  onSnapshot,
  query,
  serverTimestamp,
  updateDoc,
  where,
} from 'firebase/firestore'
import {KTCard, toAbsoluteUrl} from '../../../../_metronic/helpers'
import {ToastContainer} from 'react-toastify'
import useCrispChat from 'app/Hooks/useCrispChat'
import {showErrorToast, showSuccessToast} from 'app/components/ShowToast'
import Button from 'app/components/Button'
import {ListLoading} from 'app/components/ListLoading'

const CompanySettings = () => {
  const {currentUser, setCurrentUser, logout} = useAuth()
  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingpw, setIsLoadingpw] = useState(false)
  const [currentPassword, setCurrentPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [currentPasswordError, setCurrentPasswordError] = useState('')
  const [newPasswordError, setNewPasswordError] = useState('')
  const [confirmPasswordError, setConfirmPasswordError] = useState('')
  const [matchPasswordError, setMatchPasswordError] = useState('')
  const fileInputRef = useRef(null)
  const blankImg = toAbsoluteUrl('/media/svg/avatars/blank.svg')
  const [previewUrl, setPreviewUrl] = useState(blankImg)
  const [image, setImage] = useState(null)
  const [firstname, setFirstname] = useState('')
  const [lastname, setLastname] = useState('')
  const [email, setEmail] = useState(currentUser?.email)
  const [users, setUsers] = useState<any[]>([])
  const currentDate = new Date()
  const year = currentDate.getFullYear()
  const month = currentDate.getMonth() + 1
  const day = currentDate.getDate()
  const {toggleCrispChat} = useCrispChat()
  const todaysDate = month + '/' + day + '/' + year
  const [isDataFetching, setIsDataFetching] = useState(true)

  useEffect(() => {
    getPersonnel()
  }, [])

  const getPersonnel = () => {
    try {
      setIsDataFetching(true)
      const tenantId = currentUser?.tenantId || ''
      const email = currentUser?.email || ''
      const tenantRef = doc(db, 'tenants', tenantId)
      const employeesRef = collection(tenantRef, 'employees')

      const unsubscribe = onSnapshot(
        query(employeesRef, where('email', '==', email)),
        (snapshot) => {
          const employeeData = snapshot.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
            first_name: doc.data().first_name,
            last_name: doc.data().last_name,
            fullName: doc.data().full_name,
            email: doc.data().email,
            image_url: doc.data().image_url,
          }))
          setUsers(employeeData)
          const fullNameParts = employeeData[0].fullName.split(' ')
          setFirstname(fullNameParts[0] || '')
          setLastname(fullNameParts.slice(1).join(' ') || '')
          setEmail(email)
          setPreviewUrl(employeeData[0].image_url || blankImg)
        }
      )
      return unsubscribe
    } catch (error) {
      console.error('Error getting personnel:', error)
    } finally {
      setTimeout(() => setIsDataFetching(false), 500)
    }
  }

  const updateUsername = async (employeeId: string, newUsername: string, imageUrl: string) => {
    try {
      const tenantId = currentUser?.tenantId || ''
      const tenantRef = doc(db, 'tenants', tenantId)
      const employeeRef = doc(tenantRef, 'employees', employeeId)

      await updateDoc(employeeRef, {
        full_name: newUsername,
        first_name: firstname,
        last_name: lastname,
        image_url: imageUrl,
        updated_at: new Date(),
      })
    } catch (error) {
      console.error('Error updating username:', error)
    }
  }

  async function updateNameAcrossCollections(
    oldName: string,
    newName: string,
    tenantId: string,
    collectionName: string
  ) {
    if (!oldName || oldName === newName) {
      return
    }

    const collectionRef = collection(db, 'tenants', tenantId, collectionName)
    const q = query(collectionRef, where('owner', '==', oldName))
    const querySnapshot = await getDocs(q)

    const batch = db.batch() as unknown as WriteBatch

    const updateDocument = (docRef: DocumentReference, newName: string) => {
      batch.update(docRef, {owner: newName})
    }

    try {
      if (querySnapshot.empty) {
        return
      }

      querySnapshot.forEach((doc: QueryDocumentSnapshot<DocumentData>) => {
        updateDocument(doc.ref, newName)
      })

      await batch.commit()
    } catch (error) {
      console.error(`Failed to update documents in collection: ${collectionName}. Error: ${error}`)
    }
  }

  async function updateNameAcrossCollections2(
    oldName: string,
    newName: string,
    tenantId: string,
    collectionName: string
  ) {
    if (!oldName || oldName === newName) {
      return
    }

    const collectionRef = collection(db, 'tenants', tenantId, collectionName)
    const q = query(collectionRef, where('full_name', '==', oldName))
    const querySnapshot = await getDocs(q)

    const batch = db.batch() as unknown as WriteBatch

    const updateDocument = (docRef: DocumentReference, newName: string) => {
      batch.update(docRef, {full_name: newName})
    }

    try {
      if (querySnapshot.empty) {
        return
      }

      querySnapshot.forEach((doc: QueryDocumentSnapshot<DocumentData>) => {
        updateDocument(doc.ref, newName)
      })

      await batch.commit()
    } catch (error) {
      console.error(`Failed to update documents in collection: ${collectionName}. Error: ${error}`)
    }
  }

  async function updateNameAcrossCollections3(
    oldName: string,
    newName: string,
    tenantId: string,
    collectionName: string
  ) {
    if (!oldName || oldName === newName) {
      return
    }

    const collectionRef = collection(db, 'tenants', tenantId, collectionName)
    const q = query(collectionRef, where('control_owner', '==', oldName))
    const querySnapshot = await getDocs(q)

    const batch = db.batch() as unknown as WriteBatch

    const updateDocument = (docRef: DocumentReference, newName: string) => {
      batch.update(docRef, {control_owner: newName})
    }

    try {
      if (querySnapshot.empty) {
        return
      }

      querySnapshot.forEach((doc: QueryDocumentSnapshot<DocumentData>) => {
        updateDocument(doc.ref, newName)
      })

      await batch.commit()
    } catch (error) {
      console.error(`Failed to update documents in collection: ${collectionName}. Error: ${error}`)
    }
  }

  async function updateNameAcrossCollections4(
    oldName: string,
    newName: string,
    tenantId: string,
    collectionName: string
  ) {
    if (!oldName || oldName === newName) {
      return
    }

    const collectionRef = collection(db, 'tenants', tenantId, collectionName)
    const q = query(collectionRef, where('decisionMadeBy.name', '==', oldName))
    const querySnapshot = await getDocs(q)

    const batch = db.batch() as unknown as WriteBatch

    const updateDocument = (docRef: DocumentReference, newName: string) => {
      batch.update(docRef, {'decisionMadeBy.name': newName})
    }

    try {
      if (querySnapshot.empty) {
        return
      }

      querySnapshot.forEach((doc: QueryDocumentSnapshot<DocumentData>) => {
        updateDocument(doc.ref, newName)
      })

      await batch.commit()
    } catch (error) {
      console.error(`Failed to update documents in collection: ${collectionName}. Error: ${error}`)
    }
  }

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setIsLoading(true)
    if (firstname.trim() === '') {
      showErrorToast({message: 'First name is required'})
      setIsLoading(false)
      return
    }

    try {
      let imageUrl = previewUrl

      if (image) {
        const employeeRef = ref(
          storage,
          `tenants/${currentUser?.tenantId}/employees/${currentUser?.uid}/${(image as File).name}`
        )
        await uploadBytes(employeeRef, image)
        imageUrl = await getDownloadURL(employeeRef)
      }

      if (!currentUser) {
        throw new Error('No tenant ID found')
      }
      const tenantId = currentUser.tenantId || ''

      if (currentUser) {
        const tenantRef = doc(db, 'tenants', tenantId)
        const employeeData = users[0]
        const oldName = employeeData.fullName
        const newName = `${firstname} ${lastname}`.trim()

        const storedUser = JSON.parse(localStorage.getItem('currentUser') || '{}')
        storedUser.userName = newName
        localStorage.setItem('currentUser', JSON.stringify(storedUser))

        if (employeeData) {
          await updateUsername(employeeData.id, `${firstname} ${lastname}`.trim(), imageUrl)
        }
        await updateNameAcrossCollections(oldName, newName, tenantId, 'assets')
        await updateNameAcrossCollections(oldName, newName, tenantId, 'tasklists')
        await updateNameAcrossCollections(oldName, newName, tenantId, 'risks')
        await updateNameAcrossCollections(oldName, newName, tenantId, 'vendors')
        await updateNameAcrossCollections(oldName, newName, tenantId, 'tests')
        await updateNameAcrossCollections(oldName, newName, tenantId, 'policies')
        await updateNameAcrossCollections2(oldName, newName, tenantId, 'employees')
        await updateNameAcrossCollections3(oldName, newName, tenantId, 'controls')
        await updateNameAcrossCollections4(oldName, newName, tenantId, 'requests_access')
        setCurrentUser({
          ...currentUser,
          userName: newName || '',
        })
        await updateDoc(doc(db, 'users', currentUser?.uid || ''), {
          userName: newName || '',
          first_name: firstname,
          last_name: lastname,
        })     
        const activitiesRef = collection(tenantRef, 'activities')
        await addDoc(activitiesRef, {
          message: `User details has been updated`,
          timestamp: serverTimestamp(),
          tenantId: currentUser?.tenantId,
          uid: currentUser?.uid,
          action: 'User details updated',
          target: 'Settings',
          email: currentUser?.email,
          username: currentUser?.userName,
          date: todaysDate,
        })
        showSuccessToast({message: 'Profile details updated successfully!'})
      }
    } catch (error) {
      showErrorToast({message: 'An error occurred while updating profile details.'})
    } finally {
      setIsLoading(false)
    }
  }

  const handleImageChange = (event) => {
    const file = event.target.files[0]
    if (
      file &&
      (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg')
    ) {
      setImage(file)
      setPreviewUrl(URL.createObjectURL(file))
    } else {
      showErrorToast({message: 'Please select an image file (png, jpg, or jpeg)'})
    }
  }

  const handleUploadClick = () => {
    if (fileInputRef.current) {
      ;(fileInputRef.current as HTMLInputElement).click()
    }
  }

  const handleDelete = () => {
    setImage(null)
    setPreviewUrl(blankImg)
    if (fileInputRef.current) {
      ;(fileInputRef.current as HTMLInputElement).value = ''
    }
  }

  const handleChangePassword = async () => {
    let valid = true
    setCurrentPasswordError('')
    setNewPasswordError('')
    setConfirmPasswordError('')
    setMatchPasswordError('')

    if (!currentPassword) {
      setCurrentPasswordError('Current password is required')
      valid = false
    }

    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/
    if (!newPassword) {
      setNewPasswordError('New password is required')
      valid = false
    } else if (!passwordRegex.test(newPassword)) {
      setNewPasswordError(
        'Password must contain at least 8 characters, one uppercase, one lowercase, one number and one special character'
      )
      valid = false
    }

    if (!confirmPassword) {
      setConfirmPasswordError('Confirm password is required')
      valid = false
    } else if (newPassword !== confirmPassword) {
      setMatchPasswordError('Passwords do not match')
      valid = false
    }

    if (!valid) return

    try {
      setIsLoadingpw(true)
      const auth = getAuth()
      const user = auth.currentUser

      if (user && currentPassword) {
        const credential = EmailAuthProvider.credential(user.email as string, currentPassword)
        await reauthenticateWithCredential(user, credential)
        await updatePassword(user, newPassword)
        const userRef = doc(db, 'users', user.uid)

        await updateDoc(userRef, {
          password: newPassword,
        })
        showSuccessToast({message: 'Password changed successfully!'})
        setCurrentPassword('')
        setNewPassword('')
        setConfirmPassword('')
        setCurrentPasswordError('')
        setNewPasswordError('')
        setConfirmPasswordError('')
        setMatchPasswordError('')
        logout().catch(error => {
          console.error('Error during logout:', error)
        })
      }
    } catch (error) {
      setCurrentPasswordError('Invalid current password')
      setNewPasswordError('')
      setConfirmPasswordError('')
      setMatchPasswordError('')
      showErrorToast({message: 'Failed to change password. Please check your current password.'})
    } finally {
      setIsLoadingpw(false)
    }
  }

  return (
    <>
      {isDataFetching ? (
        <KTCard>
          <div className='position-relative' style={{height: '500px'}}>
            <ListLoading />
          </div>
        </KTCard>
      ) : (
        <>
          <KTCard className='mb-8'>
            <div className=' mw-1111px rounded bg-white '>
              <div className='modal-content '>
                <div className='modal-header border-bottom p-7 fs-6 '>
                  <h3 className='modal-title mx-3'>Profile Detail</h3>
                  <br />
                </div>
                <form
                  id='kt_modal_add_user_form'
                  className='form px-4'
                  // onSubmit={formik.handleSubmit}
                  noValidate
                  onSubmit={handleSubmit}
                >
                  <div
                    className='d-flex flex-column  me-n7 pe-12 mx-6'
                    id='kt_modal_add_user_scroll'
                    data-kt-scroll='true'
                    data-kt-scroll-activate='{default: false, lg: true}'
                    data-kt-scroll-max-height='auto'
                    data-kt-scroll-dependencies='#kt_modal_add_user_header'
                    data-kt-scroll-wrappers='#kt_modal_add_user_scroll'
                    data-kt-scroll-offset='300px'
                  >
                    <div className='row align-items-center mt-8 mb-4'>
                      <div className='col-md-2'>
                        <div
                          className='image-input image-input-empty '
                          data-kt-image-input='true'
                          style={{
                            backgroundImage: `url('${previewUrl}')`,
                            backgroundPosition: 'center',
                          }}
                        >
                          <div className='image-input-wrapper w-125px h-125px'></div>
                          <input
                            type='file'
                            name='avatar'
                            ref={fileInputRef}
                            hidden
                            accept='.png, .jpg, .jpeg'
                            onChange={handleImageChange}
                          />
                          <input type='hidden' name='avatar_remove' />
                          {/* </label> */}
                          <span
                            className='btn btn-icon btn-circle btn-color-muted btn-active-color-primary w-25px h-25px bg-body shadow'
                            data-kt-image-input-action='cancel'
                            data-bs-toggle='tooltip'
                            title='Cancel avatar'
                          >
                            <i className='ki-outline ki-cross fs-3'></i>
                          </span>
                          <span
                            className='btn btn-icon btn-circle btn-color-muted btn-active-color-primary w-25px h-25px bg-body shadow'
                            data-kt-image-input-action='remove'
                            data-bs-toggle='tooltip'
                            title='Remove avatar'
                          >
                            <i className='ki-outline ki-cross fs-3'></i>
                          </span>
                        </div>
                      </div>
                      <div className='col-md-9'>
                        <div className='mb-2 '>
                          <div className='fw-bold fs-6 fw-bliock'>Profile Picture</div>
                          <div className='fs-6'>Allowed file types: png, jpg and jpeg.</div>
                        </div>
                        <div className='d-flex mt-3' style={{gap: '12px'}}>
                          {previewUrl === blankImg ? (
                            <Button btnType='primary' onClick={handleUploadClick}>
                              Upload New Picture
                            </Button>
                          ) : (
                            <Button btnType='default' onClick={handleDelete}>
                              Delete Picture
                            </Button>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className='row align-items-center  mb-4'>
                      <div className='col-md-6'>
                        <div className='fv-row mb-3'>
                          <label className='fw-bold fs-6 mb-1'>First Name</label>
                          <input
                            placeholder='Enter first name'
                            type='text'
                            className='form-control '
                            name='firstname'
                            value={firstname}
                            onChange={(e) => setFirstname(e.target.value)}
                            autoComplete='off'
                          />
                        </div>
                      </div>
                      <div className='col-md-6'>
                        <div className='fv-row mb-3'>
                          <label className='fw-bold fs-6 mb-1'>Last Name</label>
                          <input
                            placeholder='Enter last name'
                            type='text'
                            className='form-control '
                            name='lastName'
                            value={lastname}
                            onChange={(e) => setLastname(e.target.value)}
                            autoComplete='off'
                          />
                        </div>
                      </div>
                    </div>

                    <div className='card mb-8 p-4' style={{background: '#F6F6F6'}}>
                      <div className='mt-1'>
                        <span className='fw-bold fs-6'>Email</span>
                      </div>

                      <div className='fs-6 mt-2 mb-2' style={{color: '#5A5A5A'}}>
                        We recommend keeping your account email unchanged. If incase you need to
                        change it, please{' '}
                        <span style={{color: '#0e9f6e'}} onClick={() => toggleCrispChat()}>
                          contact
                        </span>{' '}
                        our support team for assistance.
                      </div>
                      <span className='fw-semibold fs-6 mb-2'>Your Email : {email}</span>
                    </div>
                  </div>
                  <div className='modal-footer border-top d-flex justify-content-end pt-4 pe-5 mb-4'>
                    <Button btnType='primary' type='submit' disabled={isLoading}>
                      {isLoading ? 'Saving...' : 'Save'}{' '}
                      {isLoading && (
                        <span className='spinner-border spinner-border-sm align-middle'></span>
                      )}
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </KTCard>

          <div className='card'>
            <div className='card-header px-6 pt-4'>
              <h4 className='fw-bold m-4'>Change Password</h4>
            </div>
            <div className='card-body py-0 px-10'>
              <div className='fs-6 mb-4 fw-semibold mt-4' style={{color: '#5A5A5A'}}>
                Please make sure that your password is at least 8 characters long with both letters
                and numbers.
              </div>

              <div className='row align-items-center mb-4 mt-4'>
                <div className='col-md-12'>
                  <div className='fv-row mb-3'>
                    <label className='fw-bold fs-6 mb-1'>Current Password</label>
                    <input
                      placeholder='Enter current password'
                      type='password'
                      className={`form-control ${currentPasswordError ? 'is-invalid' : ''}`}
                      name='currentPassword'
                      value={currentPassword}
                      onChange={(e) => setCurrentPassword(e.target.value)}
                      autoComplete='off'
                    />
                    {currentPasswordError && (
                      <div style={{color: 'red'}}>{currentPasswordError}</div>
                    )}
                  </div>
                </div>
              </div>

              <div className='row align-items-center mb-4 mt-4'>
                <div className='col-md-12'>
                  <div className='fv-row mb-3'>
                    <label className='fw-bold fs-6 mb-1'>New Password</label>
                    <input
                      placeholder='Enter new password'
                      type='password'
                      className={`form-control ${newPasswordError ? 'is-invalid' : ''}`}
                      name='newPassword'
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      autoComplete='off'
                    />
                    {newPasswordError && <div style={{color: 'red'}}>{newPasswordError}</div>}
                  </div>
                </div>
              </div>

              <div className='row align-items-center mt-4 mb-4'>
                <div className='col-md-12'>
                  <div className='fv-row mb-3'>
                    <label className='fw-bold fs-6 mb-1'>Confirm New Password</label>
                    <input
                      placeholder='Enter confirm new password'
                      type='password'
                      className={`form-control ${
                        confirmPasswordError || matchPasswordError ? 'is-invalid' : ''
                      }`}
                      name='confirmPassword'
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      autoComplete='off'
                    />
                    {confirmPasswordError && (
                      <div style={{color: 'red'}}>{confirmPasswordError}</div>
                    )}
                    {matchPasswordError && <div style={{color: 'red'}}>{matchPasswordError}</div>}
                  </div>
                </div>
              </div>
            </div>
            <div className='card-footer py-0'>
              <div className='d-flex justify-content-end'>
                {isLoadingpw ? (
                  <button
                    className='fs-6 fw-semibold rounded border-0  my-6 '
                    // onClick={handleChangePassword}
                    style={{
                      background: '#0E9F6E',
                      color: '#fff',
                      height: '40px',
                      // width: '180px',
                      top: '20px',
                      left: '223px',
                    }}
                    disabled
                  >
                    Changing Password...
                    <span className='spinner-border spinner-border-sm align-middle m-2'></span>
                  </button>
                ) : (
                  <Button btnType='primary' className='my-6' onClick={handleChangePassword}>
                    Change Password
                  </Button>
                )}
              </div>
            </div>
          </div>
        </>
      )}
      <ToastContainer />
    </>
  )
}

export default CompanySettings
